module.exports = __webpack_public_path__ + "img/fondo-azul.8fcab183.jpg";